import React, { useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import Slider from 'react-slick';
// import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { TOI_IMAGE_DOMAIN } from 'constants';
import { loadSyncUp } from '../../../redux';
import s from './CongratulationsCardSlider.scss';

const CongratulationsCardSlider = props => {
  const { buttonClicked, resultData, isMobile, gameType } = props;
  const ref = useRef(null);

  const imageMap = {
    timerCard: {
      image: `${TOI_IMAGE_DOMAIN}/photo/121960732.cms`,
      alt: 'Time Icon',
      type: 'green',
    },
    streakCard: {
      image: `${TOI_IMAGE_DOMAIN}/photo/121960749.cms`,
      alt: 'Streak Fire',
      type: 'yellow',
    },
    genericCard: {
      image: `${TOI_IMAGE_DOMAIN}/photo/121960767.cms`,
      alt: 'Medal Icon',
      type: 'blue',
    },
    clockCard: {
      image: `${TOI_IMAGE_DOMAIN}/photo/121960666.cms`,
      alt: 'Clock Icon',
      type: 'green',
    },
  };

  const achievementCards = resultData?.achievementCards || [];

  const settings = {
    centerMode: !(
      !!achievementCards &&
      Array.isArray(achievementCards) &&
      achievementCards.length === 1
    ),
    centerPadding: '70px',
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const getCardImageData = cardType => {
    // Special handling for timerCard based on gameType
    if (cardType === 'timerCard') {
      return gameType === 'location-guesser'
        ? imageMap.timerCard
        : imageMap.clockCard;
    }
    return imageMap[cardType] || imageMap.timerCard;
  };

  const renderCard = card => {
    const imageData = getCardImageData(card.cardType);
    return (
      <div key={card.cardType} className={`${s.cardItem} ${s[imageData.type]}`}>
        <img src={imageData.image} alt={imageData.alt} />
        <div className={s.cardContent}>
          <strong>{card.primaryText || ''}</strong>
          <span>{card.secondaryText || ''}</span>
        </div>
      </div>
    );
  };

  return (
    <div className={s.congratulationsWrap}>
      {buttonClicked &&
      buttonClicked !== '' &&
      (buttonClicked === 'view_result' || buttonClicked === 'viewResult') ? (
        <></>
      ) : (
        <div className={s.confetti}>
          <figure>
            <img
              src={`${TOI_IMAGE_DOMAIN}/photo/122061048.cms`}
              alt="Confetti"
            />
          </figure>
        </div>
      )}
      <div className={s.congratulationsHeader}>
        <h1 className={s.title}>
          {resultData?.greetTitle || 'Congratulations'}
        </h1>
        <p className={s.subtitle}>You completed the challenge</p>
      </div>

      <div
        className={`${s.cardSlider} slick_UI ${
          !!achievementCards &&
          Array.isArray(achievementCards) &&
          achievementCards.length === 1
            ? 'singleItemSlider'
            : ''
        }`}
      >
        {isMobile ? (
          <Slider {...settings} ref={ref}>
            {achievementCards.map(renderCard)}
          </Slider>
        ) : (
          <div className={s.desktopFlex}>
            {achievementCards.map(renderCard)}
          </div>
        )}
      </div>

      {/* <div className={s.shareButtonWrap}>
        <button className={s.shareButton} onClick={handleShare}>
          Share this Game <i className={s.shareIcon} />
        </button>
      </div> */}
    </div>
  );
};

CongratulationsCardSlider.propTypes = {
  gameType: PropTypes.string,
  isMobile: PropTypes.bool,
};

CongratulationsCardSlider.defaultProps = {
  gameType: 'crossword',
  isMobile: false,
};

const mapStateToProps = state => ({
  isMobile: state.isMobile,
  gamesconfigData: _get(state, 'toigames.gamesconfig', {}),
});

const mapDispatchToProps = dispatch => ({
  loadSyncUp: params => dispatch(loadSyncUp(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  CongratulationsCardSlider,
);
